import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Tag } from '@blueprint/tag';
import { ZooplaColor } from '@blueprint/theme';

export type ListingTagProps = { bgColor?: ZooplaColor };

export const ListingTag = styled(Tag)<ListingTagProps>(
    ({ bgColor = 'tone-blue', theme }) => css`
        background-color: ${theme.colors[bgColor]};
    `
);

export const ListingTagsContainer = styled('div')(({ theme }) => {
    return css`
        float: right;
        width: 50%;
        text-align: right;
        margin-right: ${theme.spacing['8px']};

        ${ListingTag} {
            color: ${theme.colors.white};
            margin-bottom: ${theme.spacing['4px']};
            margin-left: ${theme.spacing['4px']};
            white-space: nowrap;

            &:first-of-type {
                margin-left: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }

            ${theme.mq.medium} {
                margin-left: ${theme.spacing['4px']};
            }
        }

        ${theme.mq.small} {
            width: 45%;
        }

        ${theme.mq.extraLarge} {
            margin-top: calc(${theme.spacing['2px']} * 3);
            margin-left: ${theme.spacing['8px']};
            margin-right: 0;
            width: auto;
            float: none;
            order: 4;
        }
    `;
});
